import React, { FC } from 'react';

import { Button } from '../../../../../../../button';
import { Modal } from '../../../../../../../modal/modal.component';
import { ModalIds } from '../../../../../../../../contexts/modals/modals.types';
import { SuccessProps } from './success.types';
import { Typography } from '../../../../../../../../../../../components';
import styles from './success.module.scss';
import { useTranslation } from 'react-i18next';

/**
 * Success component
 * @description Content for the Success stage modal of PortfoliosSettings Delete flow
 *
 * @author Oleksii Medvediev
 * @param { SuccessProps } props - SuccessProps defined in the './success.component.tsx'
 * @category Components
 */
const Success: FC<SuccessProps> = ({ onClose, accountId, clientNameOwner, portfolioMember }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'management' });

  return (
    <Modal modalId={ModalIds.portfoliosSettingsDelete} title={t('modals.portfoliosSettings.delete.success.title')}>
      <div className={styles.wrapper}>
        <Typography.Text variant={'bodyText5'} className={styles.subtitle}>
          {t('modals.portfoliosSettings.delete.success.text', {
            clientNameOwner,
            portfolioMember,
            accountId: accountId.toUpperCase(),
          })}
        </Typography.Text>
        <Button type={'button'} variant={'main'} size={'large'} onClick={onClose}>
          {t('modals.portfoliosSettings.delete.success.continue')}
        </Button>
      </div>
    </Modal>
  );
};

export { Success };
